import React from "react"

import { Pair } from "./AutoStyles"
import Input from "./Input"

export default function Section({
  name,
  value,
  handler,
  onBlur,
  infinite,
  maxLength,
  onFocus,
}: any) {
  return (
    <Pair name={name}>
      <Input
        value={value}
        handler={handler}
        onBlur={onBlur}
        infinite={infinite}
        maxLength={maxLength}
        onFocus={onFocus}
      />
    </Pair>
  )
}
